/**
 * @module application
 */

import Bugsnag from '@bugsnag/js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * Initializes the Bugsnag client.
 * Should not be called directly.
 * @see {@link module:application.bugsnag}
 *
 * @param {object} options
 * @param {string} options.apiKey - The API key, obtained from Bugsnag.
 * @param {string} [options.releaseStage='local'] - The current environment (e.g. local, stage, production,...).
 * @param {string|null} [options.appVersion=null] - Optional version identifier, used for grouping/filtering in the Bugsnag backend.
 * @returns {Promise<void>}
 * @private
 *
 * @requires module:@spinnwerk/old-browser-check
 */
export async function initBugsnag({ apiKey, releaseStage = 'local', appVersion = null }) {
    const fpPromise = FingerprintJS.load();

    global.bugsnagClient = Bugsnag.start({
        apiKey,
        appVersion,
        collectUserIp: false,
        releaseStage,
        notifyReleaseStages: ['production', 'prod', 'stage'],
        logger: null,
        onError: async (report) => {
            const fingerprint = await fpPromise,
                result = await fingerprint.get();

            report.setUser(result.visitorId);

            // also ignore some useless errors
            if (report.errorMessage === 'ResizeObserver loop limit exceeded') {
                return false;
            }
        },
    });
}
